import { InjectionToken } from '@angular/core';


export const MMU_MAINTENANCE_NOTICE_URL = new InjectionToken<string>('MMU_MAINTENANCE_NOTICE_URL', {
  providedIn: 'root',
  factory: (): string => {
    const url = new URL('https://assets.miele-move.com/maintenance/notice.json');

    if (window.location.hostname === 'localhost') {
      url.hostname = window.location.hostname;
      url.protocol = window.location.protocol;
      url.port = window.location.port;
      return url.toString();
    }

    // Replace leading 'www.' in URL for production system
    url.hostname = `assets.${window.location.hostname.replace(/^www./, '')}`;
    return url.toString();
  }
});
